import { useLocation } from "react-router";
import React, { useState, useEffect, useHistory } from "react";

import axios from "axios";
import jwt_decode from "jwt-decode";
import "../modal.css";

import Table from "./../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../Spinner";
const AgentTransactions = () => {
  const location = useLocation();
  let [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState([]);
  const usr = JSON.parse(localStorage.getItem("userData"));
  const id = usr.id;

  const getTransactions = async () => {
    const response = await axios
      .get("/agentTransactions/" + id, {})
      .then((res) => {
        setTransactions(res.data);
        setLoading(false);
        // notify()
      })
      .catch((err) => {
        notifyError();
      });
  };

  const notify = () =>
    toast.success("Vehicles list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  useEffect(() => {
    getTransactions();
  }, [location.key]);
  const columns = React.useMemo(
    () => [
      {
        Header: "Passenger",
        columns: [
          {
            Header: "First Name",
            accessor: "passenger.firstName",
          },
          {
            Header: "Last Name",
            accessor: "passenger.lastName",
          },
        ],
      },

      {
        Header: "Driver",
        columns: [
          {
            Header: "First Name",
            accessor: "driver.firstName",
          },
          {
            Header: "Last Name",
            accessor: "driver.lastName",
          },
        ],
      },

      {
        Header: "Transactions",
        columns: [
          {
            Header: "Total Price in ETB",
            accessor: "trip.actualPrice",
          },
          {
            Header: "Revenue in ETB",
            accessor: "revenue",
          },
          {
            Header: "Transaction Date",
            accessor: "trip.createdAt",
          },
        ],
      },
    ],
    []
  );

  return (
    <div className="">
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">List of Transactions</h3>
          </div>

          <div className="card-body">
            {loading && (
              <div>
                <Spinner />
              </div>
            )}
            {!loading && <Table columns={columns} data={transactions} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentTransactions;
